/**
 * Обрабатывает URL, добавляя протокол если необходимо
 * @param url - исходный URL
 * @param defaultProtocol - протокол по умолчанию (https://)
 * @returns Корректный URL с протоколом
 */
export function normalizeUrl(url: string | undefined | null, defaultProtocol = 'https://'): string {
  if (!url) return ''

  let normalized = url.trim()

  if (/^(https?|ftp|mailto):\/\//i.test(normalized)) {
    return normalized
  }

  normalized = defaultProtocol + normalized.replace(/^\/+/g, '')

  try {
    new URL(normalized)
    return normalized
  } catch (e) {
    console.error('Invalid URL after normalization:', url)
    return ''
  }
}